import type { IUploadDataItem } from "../types/domain/image";
import { generateBase64Content } from "../utils/image";

export const uploadS3 = async (store: string, images: File[] = []): Promise<string[]> => {
  const uploadData: { id: any; fileContent: unknown; s3Key: string }[] = [];

  await Promise.all(
    images.map(async (file, index) => {
      const fileContentBase64 = await generateBase64Content(file);
      uploadData.push({
        id: index,
        fileContent: fileContentBase64,
        s3Key: `${store}/${new Date().getTime()}_${file.name}`,
      });
    }),
  );

  try {
    const url = "https://moe4nxogd75rqtj2jo6yninrzu0bwbls.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, { method: "POST", body: JSON.stringify(uploadData) });
    if (response.ok) {
      const data = await response.json();
      return data.s3_urls;
    }

    return [];
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

// wellbeing에서만 사용 TODO: 추후 이걸로 교체 필요
export const uploadS3V2 = async (uploadData: IUploadDataItem[]): Promise<string[]> => {
  try {
    const url = "https://moe4nxogd75rqtj2jo6yninrzu0bwbls.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, { method: "POST", body: JSON.stringify(uploadData) });

    if (response.ok) {
      const data = await response.json();
      return data.s3_urls;
    }

    return [];
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
